import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Popover from '@material-ui/core/Popover';
import { CURSOR} from '../../../../styles/fonts/MCFontConstants';

export const CalendarPanelHeader = styled.div`
    z-index: 13;
    ${media.mobileDevice`
    width:100%;
    position: fixed;
    top: ${(props) =>
        props.calnederMargin ? props.calnederMargin : '3.6rem'} ;
    
    background-color:#140f4b;
    `}
`;

export const ContentContainer = styled.div`
    display: flex;
    padding: 16px 0 18px 0;
    align-items: center;
    justify-content: space-evenly;
    margin: 0;
    ${media.mobileDevice`
        padding: ${(props) =>
        props.isImpersonationActive ? '16px 0.95rem 18px 0.95rem' : '0 0.95rem 18px 0.95rem'} ; ;
    `}
    
`;
export const Title = styled.h2`
    font-family: 'AvenirNextWorld Demi';
    margin: 0;
    color: #140f4b;
    ${media.mobileDevice`     
    color: #ffffff;        
    `}
`;
export const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 5px 16px 6px auto;
`;
//search icon images for mobile{white} and desktop{black}
export const Icon = styled.div`
    background: url(${(props) => props.deskPath});
    width: 100%;
    height: 100%;
    cursor: ${CURSOR};
    background-repeat: no-repeat !important;
    ${media.mobileDevice`
    background: url(${(props) => props.mobilePath});    
    opacity: ${(props) => (!props.isApplyFilter ? '0' : '1')};
    /* border:1px dashed #fff;         */
    `}
`;
export const CloseIcon = styled.div`
    display: none;
    ${media.mobileDevice`
    height: 1.3rem;
    width: 1.3rem;
    margin: 4px;
    display: block;
    cursor: pointer;
    `}
`;
export const IconContainer = styled.div`
    margin: 4px;
    height: 1.875rem;
    width: 1.875rem;
    ${media.mobileDevice`
    
    `}
`;
export const SurgeryIcon = styled.div`
    margin: ${({ isFiveDigitCount }) =>
        isFiveDigitCount ? '0 10px 0 0px' : '0 10px 0 12px'};
`;
export const OptionsContainer = styled.div`
    justify-content: initial;
    ${media.mobileDevice`
    display: none;
    `}
`;
export const StyledImage = styled.img`
    display: flex;
    align-items: center;
    object-fit: contain;
    cursor: pointer;
`;
export const ActionContainer = styled.div`
    height: 38px;
    background: #e50b7e 0% 0% no-repeat padding-box;
    border-radius: 4px;
    border: 0px;
    font-family: 'AvenirNextWorld Demi';
    text-align: center;
    padding: 5px 15px;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    ${media.mobileDevice`
    border-radius: 19px;    
    `}
`;
export const ButtonLabel = styled.label`
    display: flex;
    align-items: center;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    color: #ffff;
    cursor: pointer;
    margin-right: ${({ isFiveDigitCount }) =>
        isFiveDigitCount ? '0px' : '10px'};
`;

export const FilterPopover = styled(Popover)`
    & .MuiPaper-root {
        top: ${({ filterPopOverTopPosition }) =>
            filterPopOverTopPosition
                ? `${filterPopOverTopPosition}` + '!important'
                : '141px !important'};
    }
    & .MuiPopover-paper{
        transition: all 100ms ease-in-out !important;
    }
    ${media.mobileDevice`
        z-index: 2500 !important;
        & .MuiPaper-root{
            top: 0 !important;
            left:0 !important;
        }
        & .MuiPopover-paper{
            max-width: 100vw;
            max-height: 100vh;
            transition: all 100ms ease-in-out !important;
        }
    `}
    @media screen and (orientation: landscape) and (max-width: 1366px) {
        z-index: 100000 !important;
        & .MuiPaper-root {
            top: 75px !important;
        }
    }
    @media screen and (orientation: landscape) and (max-width: 1024px) {
        z-index: 100000 !important;
        & .MuiPaper-root {
            top: 75px !important;
        }
    }
    @media screen and (orientation: landscape) and (max-height: 576px) and (pointer: coarse) {
        z-index: 100000 !important;
        & .MuiPaper-root {
            top: 0 !important;
            left: 0 !important;
        }
        & .MuiPopover-paper {
            max-width: 100vw !important;
            max-height: 100vh !important;
            width: 100vw !important;
            height: 100vh !important;
        }
    }
`;
